/**
 * Type guard for primitive scalars — `string`, `number`, `boolean` (excluding
 * `null`/`undefined`). Used at API boundaries to reject non-scalar values
 * before they get coerced to `"[object Object]"` by `String()`.
 */
export const isScalar = (value: unknown): value is string | number | boolean =>
	value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean');
